/**
 * Koin module for the Architecture feature.
 *
 * Bindings:
 * - [ArchitectureRepository] (singleton) → [ArchitectureRepository] backed by the
 *   shared [HttpClient] and [BASE_URL] string qualifier.
 * - [ArchitectureViewModel] (factory) → new instance per composable, lifecycle managed
 *   by [org.moxultimate.topwithmox.core.base.rememberViewModel].
 *
 * Replace [BASE_URL] with your actual API base URL before going to production.
 */
package org.moxultimate.topwithmox.architecture.di

import io.ktor.client.*
import io.ktor.client.engine.js.*
import io.ktor.client.plugins.contentnegotiation.*
import io.ktor.serialization.kotlinx.json.*
import kotlinx.serialization.json.Json
import org.koin.dsl.module
import org.moxultimate.topwithmox.architecture.api.ArchitectureRepository
import org.moxultimate.topwithmox.architecture.ui.ArchitectureViewModel


val architectureModule = module {

    // Shared HttpClient — singleton so the underlying JS engine is reused
    single {
        HttpClient(Js) {
            install(ContentNegotiation) {
                json(Json {
                    ignoreUnknownKeys = true
                    isLenient = true
                })
            }
        }
    }

    // Repository — singleton; holds no mutable state so it is safe to share
    single {
        ArchitectureRepository(httpClient = get())
    }

    // ViewModel — factory so each composable gets a fresh instance with its own scope
    factory {
        ArchitectureViewModel(repository = get())
    }
}
